import type { SegmentAndSubsegment } from './SegmentAndSubsegment'
import {
  BLOG_STRUCTURE_IDS,
  BOOKING_FIRST_STRUCTURE_IDS,
  BOOKINGS_EXTENDED_STRUCTURE_IDS,
  BUSINESS_STRUCTURE_IDS,
  FITNESS_BOOKINGS_STRUCTURE_IDS,
  GENERAL_BOOKINGS_STRUCTURE_IDS,
  HEALTH_BOOKINGS_STRUCTURE_IDS,
  ONLINE_STORE_STRUCTURE_IDS,
  PHYSICAL_STORE_STRUCTURE_IDS,
  RESTAURANT_STRUCTURE_IDS,
} from './segments'

type ResolveSegmentParams = {
  structureId?: string | null
}

const MAP: [string[], SegmentAndSubsegment][] = [
  [RESTAURANT_STRUCTURE_IDS, { segment: 'RESTAURANT', subSegment: 'GENERAL' }],
  [BLOG_STRUCTURE_IDS, { segment: 'BLOG', subSegment: 'GENERAL' }],
  [PHYSICAL_STORE_STRUCTURE_IDS, { segment: 'STORE', subSegment: 'PHYSICAL_STORE' }],
  [ONLINE_STORE_STRUCTURE_IDS, { segment: 'STORE', subSegment: 'ONLINE_STORE' }],
  [BOOKINGS_EXTENDED_STRUCTURE_IDS, { segment: 'BUSINESS', subSegment: 'BOOKINGS_EXTENDED' }],
  [BOOKING_FIRST_STRUCTURE_IDS, { segment: 'BUSINESS', subSegment: 'BOOKING_FIRST' }],
  [BUSINESS_STRUCTURE_IDS, { segment: 'BUSINESS', subSegment: 'GENERAL' }],
  [FITNESS_BOOKINGS_STRUCTURE_IDS, { segment: 'FITNESS', subSegment: 'FITNESS_BOOKINGS' }],
  [HEALTH_BOOKINGS_STRUCTURE_IDS, { segment: 'BOOKINGS', subSegment: 'HEALTH_BOOKINGS' }],
  [GENERAL_BOOKINGS_STRUCTURE_IDS, { segment: 'BOOKINGS', subSegment: 'GENERAL_BOOKINGS' }],
]

export const resolveSegment = (params: ResolveSegmentParams): SegmentAndSubsegment => {
  const { structureId } = params

  if (!structureId) {
    return { segment: undefined, subSegment: undefined }
  }

  const entry = MAP.find(([ids]) => ids.includes(structureId))

  if (entry) {
    return entry[1]
  } else {
    return { segment: 'REGULAR', subSegment: 'GENERAL' }
  }
}
